import { applyMiddleware, compose, legacy_createStore as createStore } from "redux";
import thunk from "redux-thunk";
import { config } from "../../services/config";
import { reducers } from "../reducers";

const composeEnhancers = config.development && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;

export const store = createStore(
	reducers,
	composeEnhancers(applyMiddleware(thunk))
);